import { render, staticRenderFns } from "./PartnerMasterDetail.vue?vue&type=template&id=20b62d58"
import script from "./PartnerMasterDetail.vue?vue&type=script&lang=js"
export * from "./PartnerMasterDetail.vue?vue&type=script&lang=js"
import style0 from "./PartnerMasterDetail.vue?vue&type=style&index=0&id=20b62d58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports